/**
 * 주소 입력 + 주소찾기 한 줄 필드.
 *
 * 병의원·약국 상세 등에서 레이아웃이 깨지지 않도록
 * 입력창(`flex-1`)과 버튼을(`shrink-0`) 항상 같은 행에 둔다.
 */
import {
  AddressSearchButton,
  type DaumAddressResult,
} from '@/shared/components/AddressSearchButton';
import { Input } from '@/shared/components/ui/input';
import { cn } from '@/shared/lib/utils';
import React from 'react';

export interface AddressSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  name?: string;
  id?: string;
  placeholder?: string;
  disabled?: boolean;
  /** 주소 선택 시 전체 Daum 결과(좌표 연동 등)가 필요할 때 */
  onSelect?: (result: DaumAddressResult) => void;
  buttonLabel?: string;
  className?: string;
  inputClassName?: string;
}

export const AddressSearchField: React.FC<AddressSearchFieldProps> = ({
  value,
  onChange,
  onBlur,
  name,
  id,
  placeholder = '주소',
  disabled = false,
  onSelect,
  buttonLabel,
  className,
  inputClassName,
}) => (
  <div className={cn('flex min-w-0 w-full items-center gap-2', className)}>
    <Input
      id={id}
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={cn('min-w-0 flex-1', inputClassName)}
    />
    <div className="shrink-0">
      <AddressSearchButton
        disabled={disabled}
        buttonLabel={buttonLabel}
        onSelect={(result) => {
          onChange(result.address);
          onSelect?.(result);
        }}
      />
    </div>
  </div>
);
